import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { Asset } from 'src/types/schema/graphql'
import HeroImage from '../components/HeroImage'
import SingleRectImage from '../components/SingleRectImage'

interface IFourImageLayout {
    assets: Asset[]
    imageClasses: string
}

const FourImageLayout: React.FC<IFourImageLayout> = ({ assets, imageClasses }) => {
    return (
        <>
            <HeroImage asset={assets[0]} imageClasses={imageClasses} />
            <div
                key={assets?.[1]?.id}
                className='col-span-2 row-span-1 hidden overflow-hidden rounded-lg sm:block'
            >
                <UI.Media
                    asset={assets?.[1]}
                    width={623}
                    height={227}
                    customWrapperClasses='object-cover h-full'
                    customClasses='h-full max-h-full w-full object-cover'
                />
            </div>
            {assets?.map((asset, index) => {
                if (index > 1) {
                    return <SingleRectImage key={index} asset={asset} />
                }
            })}
        </>
    )
}
export default FourImageLayout
